import { Injectable } from "@angular/core";
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  ActivatedRoute,
  CanActivateChild,
} from "@angular/router";
import { Observable } from "rxjs";
import { ServerUrlService } from "../services/server-url.service";

@Injectable({
  providedIn: "root",
})
export class ServerUrlGuard implements CanActivate, CanActivateChild {
  constructor(private serverUrl: ServerUrlService) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let client = next.paramMap.get("client");
    const newClient = this.serverUrl.clients.find((val) => val.name === client);

    this.serverUrl.name = client;

    if (!newClient) {
      return fetch(
        `https://cms-backend.otimusclinic.com/variables/host/${client}`,
        {
          method: "POST",
        }
      )
        .then((val) => val.json())
        .then((val) => {
          this.serverUrl.url = val.find(
            (el: any) => el.chave === `Agendamento_Web_URL`
          ).valor;
          this.serverUrl.otimusUrl = val.find(
            (el: any) => el.chave === "Otimus_URL"
          ).valor;
          return true;
        });
    }

    this.serverUrl.url = newClient.url;
    return true;
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let client = next.paramMap.get("client");
    const newClient = this.serverUrl.clients.find((val) => val.name === client);

    this.serverUrl.name = client;

    if (!newClient) {
      return fetch(
        `https://cms-backend.otimusclinic.com/variables/host/${client}`,
        {
          method: "POST",
        }
      )
        .then((val) => val.json())
        .then((val) => {
          this.serverUrl.url = val.find(
            (el: any) => el.chave === `Agendamento_Web_URL`
          ).valor;
          this.serverUrl.otimusUrl = val.find(
            (el: any) => el.chave === "Otimus_URL"
          ).valor;
          return true;
        });
    }

    this.serverUrl.url = newClient.url;
    this.serverUrl.otimusUrl = "http://localhost:2022";
    return true;
  }
}
